import produce from "immer";
import { AnyAction } from "redux";
import { initialStateType } from "./types";
import { KeycloakConstants } from "./constants";

const initialState: initialStateType = {
    logged: false,
    userRoles: [],
    userName: "",
    token: null,
    location: null,
    sub: null,
    name: null,
    email: null,
};

const KeycloakReducer = (state = initialState, action: AnyAction) =>
    produce(state, (draft) => {
        switch (action.type) {
            case KeycloakConstants.SET_LOG_IN:
                draft.logged = action.payload.logged;
                draft.userRoles = action.payload.userRoles;
                draft.userName = action.payload.userName;
                draft.token = action.payload.token;
                draft.sub = action.payload.sub;
                draft.name = action.payload.name;
                draft.email = action.payload.email;

                break;
            case KeycloakConstants.SET_LOG_OUT:
                draft.logged = false;
                draft.userRoles = [];
                draft.userName = "";
                draft.token = null;
                draft.sub = null;
                draft.name = null;
                draft.email = null;
                break;
            case KeycloakConstants.SET_LOCATION:
                draft.location = action.payload;
                break;
            default:
                return state;
        }
    });

export default KeycloakReducer;
